import { render, staticRenderFns } from "./ConnectWalletOnegate.vue?vue&type=template&id=19a0923c"
import script from "./ConnectWalletOnegate.vue?vue&type=script&lang=ts"
export * from "./ConnectWalletOnegate.vue?vue&type=script&lang=ts"
import style0 from "./ConnectWalletOnegate.vue?vue&type=style&index=0&id=19a0923c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports